import { tsValidateArray, tsValidateDynamicObject, tsValidateString, tsValidateUniqueId } from '@nu-art/ts-common';
import { knowledgeManagerDBGroup } from '@app/hcs-shared';
import { DBDef_FHIRResourceParam } from '../fhir-resource-param/index.js';
import { DBDef_FHIRResourceParamValue } from '../fhir-resource-param-value/index.js';
import { DBDef_FHIRResourceSubtype } from '../fhir-resource-subtype/index.js';
const Validator_ModifiableProps = {
    label: tsValidateString(),
    subtypeId: tsValidateUniqueId,
    params: tsValidateDynamicObject(tsValidateArray(tsValidateUniqueId), tsValidateString()),
    optionalDynamicParams: tsValidateArray(tsValidateUniqueId),
};
const Validator_GeneratedProps = {
    __fhirParamIds: tsValidateArray(tsValidateUniqueId),
    __fhirParamValueIds: tsValidateArray(tsValidateUniqueId),
};
export const DBDef_FHIRQuery = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.1', '1.0.0'],
    dbKey: 'fhir-query',
    entityName: 'fhir-query',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'fhir-query'
    },
    backend: {
        name: 'fhir-query'
    },
    dependencies: {
        subtypeId: {
            dbKey: DBDef_FHIRResourceSubtype.dbKey,
            fieldType: 'string',
        },
        __fhirParamIds: {
            dbKey: DBDef_FHIRResourceParam.dbKey,
            fieldType: 'string[]',
        },
        __fhirParamValueIds: {
            dbKey: DBDef_FHIRResourceParamValue.dbKey,
            fieldType: 'string[]',
        },
        optionalDynamicParams: {
            dbKey: DBDef_FHIRResourceParam.dbKey,
            fieldType: 'string[]',
        }
    }
};
//# sourceMappingURL=db-def.js.map